<div [hidden]="selectedTransaction != undefined">
  <app-filterable-table
    #transactionTable
    [tableView]="transactionsTableView"
    (initialized)="handleTableInitialized()"
    (selectedRecord)="handleRecordSelected($event)"
  ></app-filterable-table>
</div>

<div [hidden]="selectedTransaction == undefined">
  <p>
    <input
      type="button"
      value="close"
      class="button_primary button_var_2"
      (click)="btnCloseDetails_clicked()"
    />
  </p>

  <div style="padding: 15px; border: 1px solid #dddddd">
    <app-transaction-details
      [transaction]="selectedTransaction"
    ></app-transaction-details>
  </div>
</div>
